if (!customElements.get("popup-overlay")) {
  customElements.define(
    "popup-overlay",
    class PopupOverlay extends ModalDialog {
      constructor() {
        super();
        this.delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        this.dismissDuration = (parseInt(this.dataset.dismissDays, 10) || 30) * 24 * 60 * 60 * 1000;
        this.id = this.getAttribute("id");
        this.moved = true;
        this.addEventListener("click", (event) => {
          if (event.target.closest("[data-popup-dismiss]")) this.hide();
        });
      }

      connectedCallback() {
        if (!this.hasActiveDismissal() && !Shopify.designMode) {
          setTimeout(() => {
            this.show();
          }, this.delay);
        }

        return super.connectedCallback();
      }

      hasActiveDismissal() {
        try {
          const storedValue = localStorage.getItem(this.id);
          if (!storedValue) return false;

          if (storedValue === "dismissed") {
            localStorage.setItem(this.id, Date.now().toString());
            return true;
          }

          const dismissedAt = parseInt(storedValue, 10);
          if (Number.isNaN(dismissedAt)) {
            localStorage.removeItem(this.id);
            return false;
          }

          return Date.now() - dismissedAt < this.dismissDuration;
        } catch (error) {
          return false;
        }
      }

      show() {
        super.show();
        document.body.classList.remove("overflow-hidden");
        const event = new CustomEvent("popup-overlay:open", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);
      }

      hide() {
        super.hide();
        const event = new CustomEvent("popup-overlay:close", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);

        if (!Shopify.designMode) {
          try {
            localStorage.setItem(this.id, Date.now().toString());
          } catch (error) {
            // Storage can be unavailable in strict privacy modes.
          }
        }
      }
    },
  );
}
